/**
 * 根据身份证获取生日
 *
 * @param {number|string} idCard
 * @returns {string} 出生年月日
 *
 * ```
 * const a = getBirthdayFromIdCard('130503670401001');
 * const b = getBirthdayFromIdCard('420983198907153238');
 * ```
 */
export function getBirthdayFromIdCard(idCard) {
  const idNumber = typeof idCard === "number" ? `${idCard}` : idCard;
  const birthday =
    idNumber.length === 15
      ? `19${idNumber.substr(6, 6)}`
      : idNumber.substr(6, 8);
  return birthday.replace(/(.{4})(.{2})/, "$1-$2-");
}

/**
 * 根据生日获取年龄
 *
 * @param {string} birthday 出生年月日
 * @returns {number} 年龄
 *
 * ```
 * getAgeFromBirthday('1990-02-17') // 29
 * getAgeFromBirthday('1990-02-16') // 30
 * getAgeFromBirthday('1990-02-15') // 30
 * ```
 */
export function getAgeFromBirthday(birthday) {
  if (!birthday) return '';
  const dateBirthday = new Date(birthday);
  const now = new Date();

  const monthBirthday = dateBirthday.getMonth();
  const monthNow = now.getMonth();

  const offset =
    monthBirthday > monthNow ||
    (monthBirthday === monthNow && now.getDate() < dateBirthday.getDate())
      ? 1
      : 0;

  const age = now.getFullYear() - dateBirthday.getFullYear() - offset;
  return age;
}



// WEBPACK FOOTER //
// ./src/common/birthday.js